import { createBooleanSchema, createObjectSchema, createStringSchema } from '@dreryk/react-draft';

import { DiseaseSelection } from '../../shared/autossugest/DiseaseAutosuggest.types';

import { DiagnosesWithBodySideFormPart } from './diagnosesWithBodySideFormPart.types';
import { DiagnosesWithBodySideInteractiveTable } from './table/DiagnosesWithBodySideInteractiveTable';
import { BodySide, DiagnosesWithBodySideTableBean } from './table/DiagnosesWithBodySideInteractiveTable.types';

const createBean = (bean?: Partial<DiagnosesWithBodySideFormPart>): DiagnosesWithBodySideFormPart => {
   return {
      selection: bean?.selection ?? null,
      value: bean?.value,
   };
};

const draftSchema = createObjectSchema<DiagnosesWithBodySideFormPart>({
   selection: createObjectSchema<Exclude<DiseaseSelection, null>>({
      code: createStringSchema(),
      name: createStringSchema(),
   }).nullable(),
   value: createObjectSchema<DiagnosesWithBodySideTableBean>({
      code: createStringSchema(),
      name: createStringSchema(),
      main: createBooleanSchema(),
      bodySide: createObjectSchema<BodySide>({ left: createBooleanSchema(), right: createBooleanSchema() }),
   })
      .optional()
      .array(),
});

export const diagnosesWithBodySideFormPart = {
   createBean: createBean,
   draftSchema: draftSchema,
   InteractiveTable: DiagnosesWithBodySideInteractiveTable,
};
